enum FileStatus {
  temporary = 'temporary',
  active = 'active',
  archived = 'archived',
}

export default FileStatus
